import urls from "../urls";
import { ObjectName } from "./enums";

const LIST_API_BY_OBJECTS = {
  [ObjectName.Generator]: (siteId: number) => urls.api.generators({ siteId }),
  [ObjectName.Consumer]: urls.api.consumers,
  [ObjectName.Storage]: urls.api.storages,
  [ObjectName.Person]: urls.api.personsByVariantId,
  [ObjectName.Connection]: urls.api.connections,
  [ObjectName.GasConnection]: urls.apiWithoutCamelization.gasConnections,
  [ObjectName.Meter]: urls.api.meters,
  [ObjectName.GhostNode]: urls.api.ghostNodes,
  [ObjectName.MarketLocation]: urls.api.marketLocations,
  [ObjectName.MeteringLocation]: urls.api.meteringLocations,
  [ObjectName.MeteringOrMarketLocation]: urls.api.meteringOrMarketLocations
} as const;

/** Returns list URL for a given ObjectName. */
export function getObjectListUrl(
  objectName: ObjectName,
  siteOrVariantId: number
) {
  return LIST_API_BY_OBJECTS[objectName](siteOrVariantId);
}
